import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountRelationDetail  {
    _originalTypeClassName = "zERP.BO.AccountRelationDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountRelationDetail.translate = translateService;
}
this.AccountRelationDetailID = null;
this.Percentage = null;
this.isOpposite = false;
this._key = this.AccountRelationDetailID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountRelationDetailID:any;
get AccountRelationDetailID(): any {
    return this._AccountRelationDetailID;
  }
set AccountRelationDetailID(value: any) {
    this._AccountRelationDetailID = value;
    this._key = value;
  }
Percentage:any;
isOpposite:any;
AccountingEvent:any;
DetailAccount:any;
static setAccountingEvent = ($this, value) => {
var oldValue = $this.AccountingEvent;
$this.AccountingEvent = value;
if (value != null) {
}
}
static setDetailAccount = ($this, value) => {
var oldValue = $this.DetailAccount;
$this.DetailAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountRelationDetailID == null || $this.AccountRelationDetailID == 0;
            }


}